import BoldIcon from 'components/icons/bold/index.vue';
import ItalicIcon from 'components/icons/italic/index.vue';

export default {
  name: 'EditorBar',
  components: {
    BoldIcon,
    ItalicIcon
  },
  props: {
    editor: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    // Methods to handle editor actions
    const handleBold = () => {
      props.editor.chain().focus().toggleBold().run();
    };

    const handleItalic = () => {
      props.editor.chain().focus().toggleItalic().run();
    };

    return {
      handleBold,
      handleItalic
    };
  }
};
